import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {isObjectEmpty, buildUniqueArrayFromField, toArray} from '../../../Utils';
import {toTime, pipe, map, toTimeType} from '../../../Utils';

const ContainerComp = ({pageState}) =>{

    function getTableData(){    
        const {summaryData, programs} = pageState;
        if(isObjectEmpty(summaryData)) return;
        let progIDList = buildUniqueArrayFromField(toArray(summaryData), 'ProgID');

        let programList = pipe(
            map(progID => programs[progID.toUpperCase()]),
            map(progRec => {
                return {progData: progRec, marks: summaryData.reduce((acc, summaryRec) => {
                        if(progRec.id.toUpperCase() === summaryRec.ProgID.toUpperCase()){ 
                            acc.QuestionsRight += parseInt(summaryRec.QuestionsRight);
                            acc.QuestionsAttempted += parseInt(summaryRec.QuestionsAttempted);
                            acc.time += parseInt(summaryRec.CumulativeTime)+parseInt(summaryRec.CumulativeIdleTime); 
                            acc.correct = acc.QuestionsRight + ' / ' + acc.QuestionsAttempted;
                            acc.percent = Math.round(acc.QuestionsRight/acc.QuestionsAttempted*100);
                            acc.logins ++;
                        }
                        return acc;
                    },{QuestionsRight:0, QuestionsAttempted:0, time: 0, correct:'no marks', percent:'no marks', logins:0})
                };
            })
        )(progIDList); 
 
        return programList;   
    }
    return <><ProgramsComp tableData={getTableData()} totals={pageState.schoolData}/></>;
};

Array.prototype.removeDuplicates = function(){
    return this.reduce((result,nextItem)=>
        result.includes(nextItem) ? result : result.concat(nextItem)
    ,[]);
};

const ProgramsComp = ({tableData, totals}) => {
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col  style={{textAlign: 'left'}} xs='4'> </Col>
        <Col style={{textAlign: 'center'}} xs='2'>Logins</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Questions Correct</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Percent</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
    </Row>;

    return (
        <Container>
            {/* {totals.logins>1200 && <center style={{color:'red'}}>*** This summary might be incomplete, please try changing to a smaller date range ***</center>}   */}
            {titleRow}
            {tableData.map((progRec, prog_i) => <span key={prog_i}>
                    <ProgramRow data={{title: progRec.progData.title, logins: progRec.marks.logins, correct: progRec.marks.correct, percent:progRec.marks.percent, time:progRec.marks.time}} />
                </span>
            )}
            <Row><Col xs='12'></Col></Row>
            <ProgramRow data={{title: 'Total', logins: totals.logins, correct: totals.correct, percent:totals.percent, time:totals.time}} fontWeight={'bold'}/>
        </Container>
    );
};
ProgramsComp.propTypes = {
    tableData: PropTypes.array
};

const ProgramRow = (props) => {
    const { title, logins, correct, percent, time} = props.data;

    return (
        <Row>
            <Col style={{textAlign: 'left', fontWeight: props.fontWeight}} xs='4'> {title} </Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{logins}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{correct}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{isNaN(percent)?'-':`${percent}%`}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(time)} {toTimeType(time)}</Col>
        </Row>
    );
};

ProgramRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};

export default ContainerComp;
